import { useState, useEffect, useContext, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";

import { Card } from "@mui/material";

import toast from "react-hot-toast";
import moment from "moment";

import Prompt from "components/UpStyled/Prompt";
import api from "services/api";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import Tooltip from "@mui/material/Tooltip";
import Switch from "@mui/material/Switch";

import { AccountContext } from "context/account";

import DoneIcon from "@mui/icons-material/Done";
import UndoIcon from "@mui/icons-material/Undo";
import AddIcon from "@mui/icons-material/Add";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import AddEventModal from "./AddEventModal";
import EventModalViewer from "pages/de/dashboard/components/EventModalViewer";
import Stack from "@mui/material/Stack";

import { getFileImage, getStyleImages, canResizeImageUrl } from "utils/imageHelper";
import { matchResourceUrl, convertDbToEvent } from "utils/helper";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";
import { Empty } from "antd";

const POPUP_ZINDEX = 1050;

const ToDoList = ({
  currentEvents,
  handleRefresh = () => {},
  handleChangeCalendarView = () => {},
  calRef,
}) => {
  const [addEventVisible, setAddEventVisible] = useState(false);
  const [editEventVisible, setEditEventVisible] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState({});
  const [isShowCompleted, setIsShowCompleted] = useState(true);
  const [filteredEvents, setFilteredEvents] = useState(currentEvents);
  const [viewEventVisible, setViewEventVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);

  const navigate = useNavigate();

  const account = useContext(AccountContext);
  const newSelectedInfo = {
    date: moment().startOf("minute").toDate(),
    allDay: false,
    view: {
      calendar: calRef?.current?.getApi(),
    },
  };

  const handleMarkStatus = async (id, status) => {
    try {
      let payload = {
        status: status,
      };

      const newCreatedEvent = await api.calendar.updateEvent(id, payload);
      toast.success(`Mark ${status} successfully!`);

      handleRefresh();
    } catch (err) {
      console.log(err);
      toast.error(`Mark ${status} failed!`);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      await api.calendar.deleteEvent(selectedEvent?.id);
      handleRefresh();
      setDeleteVisible(false);
      handleClose();
      toast.success(`Delete event:${selectedEvent?.title} successfully!`);
    } catch (err) {
      toast.error(`Delete event:${selectedEvent?.title} failed!`);
      console.log(err);
    }
  };

  return (
    <SuiBox sx={{ px: 1 }}>
      <SuiBox
        sx={{ mb: 1, mx: 1 }}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <SuiBox>
          <SuiTypography variant="body2" fontWeight="bold" display="inline" sx={{ mr: 0.5 }}>
            Show Completed
          </SuiTypography>
          <Switch
            checked={isShowCompleted}
            onChange={(e) => {
              const isCheckd = e?.target?.checked;
              setIsShowCompleted(isCheckd);
            }}
          />
        </SuiBox>
        <SuiBox>
          <SuiButton
            variant="gradient"
            size="small"
            color="dark"
            sx={{
              padding: "0px 8px",
              fontSize: 12,
              lineHeight: 0,
              minHeight: 30,
              textTransform: "capitalize",
              borderRadius: "4px",
              mb: 0.5,
            }}
            onClick={() => setAddEventVisible(true)}
          >
            <AddIcon fontSize="small" color="white" sx={{ mr: 0.5 }} />
            New Task
          </SuiButton>
        </SuiBox>
      </SuiBox>

      <SuiBox sx={{ px: 1, overflow: "auto" }}>
        {currentEvents.length > 0 ? (
          currentEvents.map((e) => {
            const date = moment(e?.start_time).format("MMM DD,YYYY");
            const title = e?.title;
            if (!isShowCompleted && e.status == "completed") {
              return null;
            }

            return (
              <SuiBox sx={{ my: 0.5 }}>
                <SuiBox display="flex" justifyContent="space-between" alignItems="center">
                  <SuiBox>
                    <SuiBadgeDot
                      color={e.status == "completed" ? "success" : "info"}
                      style={{ display: "inline-block" }}
                    />
                    <SuiTypography
                      sx={{
                        display: "inline",
                        cursor: "pointer",
                      }}
                      className={`${e.status == "completed" ? "line-through" : ""}`}
                      color={e.status == "completed" ? "secondary" : "dark"}
                      onClick={() => {
                        setSelectedEvent(e);
                        setViewEventVisible(true);
                      }}
                    >
                      <strong>{date}</strong> <span style={{ marginLeft: 8 }}>{title}</span>
                    </SuiTypography>
                    {/*Images are too small, there is no need to display these thumbnails*/}
                    {/* {e?.content?.resources ? (
                      <SuiBox ml={3} display="flex" gap={0.5}>
                        {" "}
                        {e.content.resources.map((item) => {
                          let img = {};
                          let title = "";
                          if (item.resourceType == "style") {
                            const styleImages = getStyleImages(item, false);
                            img = styleImages[0];
                            title = item?.title;
                          } else if (item.resourceType == "moodboard") {
                            img = item.img;
                            title = item?.name;
                          } else if (item.resourceType == "project") {
                            const products = item?.products || [];
                            let styleImages = [];
                            //add style first image
                            for (let i = 0; i < products.length; i++) {
                              const temp = getStyleImages(products[i], false);
                              styleImages.push(...temp);
                            }
                            img = styleImages[0];
                            title = item?.name;
                          } else if (item.resourceType == "collection") {
                            img = item.moodboard?.[0]?.img;
                            title = item?.title;
                          }

                          return (
                            <SuiBox sx={{ width: 40, height: 40 }}>
                              <Tooltip title={title}>
                                <Link to={matchResourceUrl(item)}>
                                  <ImageCardWrapper
                                    data={img}
                                    mode={"normal"}
                                    height={40}
                                    width={40}
                                    iconMode
                                  />
                                </Link>
                              </Tooltip>
                            </SuiBox>
                          );
                        })}
                      </SuiBox>
                    ) : null} */}
                  </SuiBox>
                  <SuiBox display="flex" gap={0.5}>
                    <Tooltip title="Delete task">
                      <DeleteOutlineOutlinedIcon
                        color="error"
                        fontSize="small"
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedEvent(e);
                          setDeleteVisible(true);
                        }}
                      />
                    </Tooltip>

                    <Tooltip title="Edit task">
                      <EditIcon
                        color="text"
                        fontSize="small"
                        sx={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedEvent(e);
                          setViewEventVisible(false);
                          setEditEventVisible(true);
                        }}
                      />
                    </Tooltip>

                    {e.status == "completed" ? (
                      <Tooltip title="Mark uncompleted">
                        <UndoIcon
                          color="error"
                          fontSize="small"
                          sx={{ cursor: "pointer" }}
                          onClick={() => handleMarkStatus(e.id, "uncompleted")}
                        />
                      </Tooltip>
                    ) : (
                      <Tooltip title="Mark completed">
                        <DoneIcon
                          color="success"
                          fontSize="small"
                          sx={{ cursor: "pointer" }}
                          onClick={() => handleMarkStatus(e.id, "completed")}
                        />
                      </Tooltip>
                    )}
                  </SuiBox>
                </SuiBox>
              </SuiBox>
            );
          })
        ) : (
          <Empty description="Task Complete" />
        )}
      </SuiBox>

      {editEventVisible && selectedEvent ? (
        <AddEventModal
          visible={editEventVisible}
          selectInfo={{ event: convertDbToEvent(selectedEvent) }}
          isEdit={true}
          handleClose={() => setEditEventVisible(false)}
          handleRefresh={handleRefresh}
          selectedType={"task"}
        />
      ) : null}
      {viewEventVisible && selectedEvent ? (
        <EventModalViewer
          visible={viewEventVisible}
          selectInfo={{ event: convertDbToEvent(selectedEvent) }}
          handleOpenEdit={() => {
            setViewEventVisible(false);
            setEditEventVisible(true);
          }}
          handleClose={() => setViewEventVisible(false)}
          handleRefresh={handleRefresh}
        />
      ) : null}
      {addEventVisible ? (
        <AddEventModal
          visible={addEventVisible}
          selectInfo={newSelectedInfo}
          handleClose={() => setAddEventVisible(false)}
          handleRefresh={() => {
            handleRefresh();
          }}
          selectedType={"task"}
        />
      ) : null}
      {deleteVisible && selectedEvent?.id ? (
        <Prompt
          heading="Delete Event"
          text={`Are you sure you want to delete the event: ${selectedEvent?.title}`}
          visible={deleteVisible}
          okText="Delete"
          okColor="error"
          handleOk={() => {
            handleConfirmDelete();
          }}
          handleClose={() => setDeleteVisible(false)}
          option={{ sx: { zIndex: POPUP_ZINDEX + 2 } }}
        />
      ) : null}
    </SuiBox>
  );
};

export default ToDoList;
